import {Cleaner} from '@yandex-int/pythia-libs/lib/markdown-renderer';

export const cleaner = Cleaner([
    'blockquote',
    'fence',
    'code',
    'heading',
    'paragraph',
    'backticks',
    'emphasis',
    'strikethrough',
    'image',
    'link',
    'text',
    'escape'
]);

export function extractCleanText(str: string) {
    const span = document.createElement('span');

    span.innerHTML = str;

    return span.textContent || span.innerText;
}

export function isChar(s: string) {
    return /^.$/u.test(s);
}
